import {
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Dropdown, Modal, Tag, Typography } from "antd";
import { FC, useState } from "react";
import {
  deleteAdvert,
  publishAdvert,
  removeAdFromPublication,
} from "../ListItems/Services";
import { useQueryClient } from "react-query";
import endPoints from "apps/CustomerPanel/MLS/Components/Portfolio/EndPoints";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaDrawer } from "apps/Common/MazakaDrawer";
import AddOrUpdateIndex from "apps/CustomerPanel/MLS/Components/AddOrUpdate/AddOrUpdateIndex";
import { ItemType } from "antd/es/menu/interface";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { removeMLS } from "apps/CustomerPanel/MLS/Components/MLSPortFolio/Services";
import { handleSetColorTitleStatus } from "apps/Common/SetColorTitleStatus";
interface PortfolioListViewOptionsProps {
  item: any;
}
const PortfolioListViewOptions: FC<PortfolioListViewOptionsProps> = ({
  item,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isShowCreateMLSDrawer, setIsShowCreateMLSDrawer] = useState(false);
  const{userInfoes} = useSelector((state:RootState)=>state.profile)
  const [searchParams,setSearchParams] = useSearchParams()
  const { Text } = Typography;
  const confirm = (type: number) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu ilan ${
        type === 1
          ? "yayından kaldırılacak"
          : type === 3
          ? "yayınlanacak"
          : "silinecek"
      }. Onaylıyor musunuz?`,
      okText: type === 1 ? "Kaldır" : type === 3 ? "Yayınla" : "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          if (type === 1) {
            await removeAdFromPublication(item);
          } else if (type === 3) {
            await publishAdvert(item);
          } else {
            await deleteAdvert(item);
          }

          queryClient.resetQueries({
            queryKey: endPoints.getUserAdvertList,
            exact: false,
          });

          openNotificationWithIcon("default", "İşlem Başarılı");
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  console.log(item)

  const tableItemDropdownMenu = (): ItemType[] => [
    {
      key: "1",
      onClick: async (e) => {
        e.domEvent.stopPropagation();
        handleEditAdvert();
      },
      icon: <EditOutlined />,
      label: "Güncelle",
    },
    ...(item.status === 2
      ? [
          {
            key: "2",
            onClick: (e:any) => {
              e.domEvent.stopPropagation();
              confirm(1);
            },
            icon: <EyeOutlined />,
            label: "Yayından Kaldır",
          },
        ]
      : []),

    ...(item.status === 0
      ? [
          {
            key: "4",
            onClick: (e:any) => {
              e.domEvent.stopPropagation();
              confirm(3);
            },
            icon: <EyeOutlined />,
            label: "Yayınla",
          },
        ]
      : []),

    {
      key: "3",
      onClick: (e) => {
        e.domEvent.stopPropagation(); 
        confirm(2);
      },
      icon: <DeleteOutlined />,
      label: "Sil",
    },
  ];
 

  const handleEditAdvert = () => {
    navigate(`/admin/panel?activePanelMenu=adManagement&id=${item.id}`);
  };
   const removeMLSConfirm = () => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu ilan PPS'i  kaldırılacak. Onaylıyor musunuz?`,
      okText: "Kaldır" ,
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          

         await removeMLS(item)

          queryClient.resetQueries({
            queryKey: endPoints.getUserAdvertList,
            exact: false,
          });

          openNotificationWithIcon("default", "İşlem Başarılı");
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };
  return (
    <>
      <Tag className="!hidden lg:!block"  color={handleSetColorTitleStatus("color", item.status)}>
        {handleSetColorTitleStatus("title", item.status)}
      </Tag>

{
 ( userInfoes?.userType ===2||userInfoes?.userType===3) &&item.status===2&&
  
  <>
  
      <MazakaButton
    
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if(item.useInPps          )
          {
            removeMLSConfirm()
          }
          else{
            setIsShowCreateMLSDrawer(true);
            setSearchParams({ id: item.id });

          }
        }}
        type="primary"
        icon={
          item.useInPps ? (
            <>
              <MinusOutlined />
            </>
          ) : (
            <>
              <PlusOutlined />
            </>
          )
        }
        className={`
          !hidden lg:!flex 
          ${item.useInPps ? "!bg-red-500" : "!bg-[#FFC502]"} ${
          item.useInPps ? "!text-white" : "!text-black"
        } `}
      >
        {item.useInPps ? "PPS'i  Kaldır" : "PPS'a Ekle"}
      </MazakaButton>
  </>
}

      <span className="!border !border-gray-300 !p-1 lg:!p-2 !rounded-md !flex items-center "  onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items: tableItemDropdownMenu() }}>
          <EllipsisOutlined  className="!text-lg lg:!text-xl"  />
        </Dropdown>
      </span>

      <MazakaDrawer
        title={<Text className="!font-bold !text-2xl">PPS ilan oluştur</Text>}

       
        open={isShowCreateMLSDrawer}
        toggleVisible={() => {
          setIsShowCreateMLSDrawer(!isShowCreateMLSDrawer);
         
        }}
      >
        <AddOrUpdateIndex selectedRecord={item} onFinish={()=>{
          setIsShowCreateMLSDrawer(!isShowCreateMLSDrawer);
        }} />
      </MazakaDrawer>
    </>
  );
};

export default PortfolioListViewOptions;
